import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledBackLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: max-content;
    margin-bottom: 12px;
    color: #737373;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    text-decoration: none;
    transition: color 0.18s ease;

    .anticon {
        font-size: 13px;
    }

    &:hover,
    &:focus {
        color: #c80707;
        text-decoration: none;
    }

    &:focus-visible {
        outline: 3px solid #ffd6d6;
        outline-offset: 3px;
        border-radius: 4px;
    }
`;

export const BackToModesLink = ({ className = undefined }) => (
    <StyledBackLink className={className} to="/" aria-label="Zpět na výběr herního módu">
        <ArrowLeftOutlined />
        <span>Zpět na výběr herního módu</span>
    </StyledBackLink>
);
